export default __webpack_public_path__ + "static/media/laponia_thumb.04787acb.jpg";